import React from "react";

import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
} from "../../components/ui/card";
import { ArrowLeft } from "lucide-react";
import Header from "../../layouts/Header";
import HideZeroBalanceRow from "../../components/HideZeroBalanceRow";
import HideAllBalancesRow from "../../components/HideAllBalancesRow";
import Toaster from "../../components/ui/toaster";
import { useNavigate } from "react-router-dom";

export default function SettingsWallets() {
  const navigate = useNavigate();

  return (
    <>
      <Toaster />
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div
          className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white"
          onClick={() => {
            navigate("/settings/index");
          }}
        >
          <ArrowLeft className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20 hover-p-2" />
          <p className="text-[16px] font-medium">Settings / Wallets</p>
        </div>

        {/* Main Content */}
        <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full">
            <Card className="bg-white rounded-2xl shadow-sm">
              <CardHeader className="px-6 pt-6 pb-4">
                <CardTitle className="text-[20px] font-semibold text-gray-500">
                  Wallets
                </CardTitle>
              </CardHeader>

              <CardContent className="px-6 pb-6">
                {/* Digital Wallet */}
                {/* <DigitalWallet /> */}

                <p className="text-sm text-text-muted text-[16px] mt-2 mb-3">
                  Manage tokens
                </p>

                <div className="space-y-3">
                  <HideAllBalancesRow />
                  <HideZeroBalanceRow />
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
